import Repository from './Repository'
import CrudRepository from './CrudRepository'
export default class ProductCategoryRepository extends CrudRepository {
  constructor () {
    super('core/api/products/web')
  }

  async getByType (type) {
    const response = await Repository.get(`${this.resource}/${type}`)
    return response
  }
}
